<template lang="pug">
    div.configurator

        span  Enter credentials

        // SSession name
        v-text-field(
            :label="$t('fields.session_name')"
            v-model="model.session_name"
            v-validate="'required'"
            outlined
        )

        // Password
        v-text-field(
            :label="$t('fields.password')"
            v-model="model.password"
            v-validate="'required'"
            outlined
        )

        // Target name
        v-text-field(
            :label="$t('fields.target_name')"
            v-model="model.target_name"
            v-validate="'required'"
            outlined
        )

        // User name
        v-text-field(
            :label="$t('fields.user_name')"
            v-model="model.user_name"
            v-validate="'required'"
            outlined
        )

        div.text-right
            v-btn(
                v-on:click="submit"
                large
                color="primary"
                :loading="isLoading"
                :disabled="isLoading"
                ) Save credentials

</template>

<script>
    import { markets } from '~api';
    import { Handler } from '~services';

    export default {
        $_veeValidate: {
            validator: 'new',
        },
        data() {
            return {
                model: {
                    session_name: '',
                    password: null,
                    target_name: '',
                    user_name: '',
                },
                isLoading: false,
            };
        },
        methods: {
            /**
             * Create user and redirect to confirmation registration page
             */
            async submit() {
                this.isLoading = true;

                const validation = await this.$validator.validateAll();
                if (!validation) return;

                const resp = await markets.saveMarketCredentials(this.model);

                Handler.handleResponse(resp, resp.data, resp.data);

                this.isLoading = false;
            },
        },
    };
</script>

<style lang="stylus" scoped></style>
